import { createUpdateWidgetDetailsMessage } from 'calling-cross-tab-library/messages/ToWorkerMessages';
import AppDataManager from '../calling-cross-tab-utils/AppDataManager';
import CrossTabConfig from '../calling-cross-tab-utils/CrossTabConfig';
import WorkerConnection from '../WorkerConnection';
import { getInitialAppData } from 'calling-cross-tab-library/appData/constants/InitialAppData';
import ActiveCallManager from './ActiveCallManager';
export function onDisconnect() {
  const {
    connectionId
  } = CrossTabConfig.get();
  const widgetDetails = AppDataManager.getAppData().widgetDetails;
  if (widgetDetails.standaloneConnectionId === connectionId) {
    const {
      standaloneConnectionId,
      activeCallDetails,
      callStatus,
      criticalFailureReason,
      callsV1SettingsUsage,
      transferInformation,
      twilioDeviceStatus
    } = getInitialAppData().widgetDetails;
    WorkerConnection.sendMessage(createUpdateWidgetDetailsMessage({
      originConnectionId: connectionId,
      widgetDetails: {
        standaloneConnectionId,
        activeCallDetails,
        callStatus,
        criticalFailureReason,
        callsV1SettingsUsage,
        transferInformation,
        twilioDeviceStatus
      }
    }));
  } else if (widgetDetails.activeCallDetails && ActiveCallManager.shouldResetActiveCallData) {
    ActiveCallManager.resetActiveData(connectionId);
  }
}